import angular from 'angular';

export class DashboardSummaryService {
    createDashboardSummaries(dashboards, items) {
        return dashboards.map(dashboard =>
            this.createDashboardSummary(dashboard, items));
    }

    createDashboardSummary(dashboard, items) {
        const res = angular.copy(items)
            .reduce(dashboard.reduce || reduceIdentity, [])
            .sort(dashboard.sort || angular.identity)
            .map(function (item) {
                // Apply formatting.
                const res = {};
                dashboard.columns.forEach(function (column) {
                    const propertyMapper = column.property || fieldIdentity(column.field);
                    res[column.field] = kendo.format(column.format || "{0}",
                        propertyMapper(item));
                });
                return res;
            });
        return {
            dashboard: dashboard,
            items: res.slice(0, dashboard.limit === undefined ? res.length : dashboard.limit)
        };
    }
}

/**
 * Create an identity function that accesses the property of the item with the given field name.
 */
function fieldIdentity(field) {
    return function (item) {
        return item[field];
    };
}

/**
 * A reducer that, when passed to an array's reduce method, returns the original array.
 */
function reduceIdentity(c, v, i, a) {
    return a;
}
